import { getRequest, postRequest } from "../../apis/axiosAction";
// ユーザー情報のメモリキャッシュ
let cachedUserInfo = null;
/**
 * ユーザー情報を取得する
 * @param isLoading ローディング表示するかどうか
 * @returns ユーザー情報
 */
export const getUserInformation = async (isLoading = true) => {
    const digitalToolsUrl = process.env.DIGITAL_TOOLS_URL;
    const url = `${digitalToolsUrl}j21spb32/v2/users/info/get-user-information`;
    return await getRequest(url, isLoading);
};
/**
 * ユーザー情報を取得する
 * メモリにある場合は再取得せずにメモリを返す
 * @param isLoading ローディング表示するかどうか
 * @returns ユーザー情報
 */
export const getUserInformationCached = async (isLoading = true) => {
    if (cachedUserInfo) {
        console.log('[UserManager] メモリからユーザー情報を取得');
        return cachedUserInfo;
    }
    // APIから取得してメモリに保存
    console.log('[UserManager] APIからユーザー情報を取得');
    cachedUserInfo = await getUserInformation(isLoading);
    return cachedUserInfo;
};
/**
 * ユーザーの列設定を保存する
 * @param columnSettings 列設定データ
 * @param isLoading ローディング表示するかどうか
 * @returns API レスポンス
 */
export const saveUserColumnSettings = async (columnSettings, isLoading = false) => {
    const digitalToolsUrl = process.env.DIGITAL_TOOLS_URL;
    const url = `${digitalToolsUrl}j21spb32/v1/user/settings`;
    const requestData = {
        typeName: "column_order",
        timestamp: Date.now(),
        settings: columnSettings
    };
    return await postRequest(url, requestData, false, isLoading);
};
/**
 * ユーザー情報から列設定を抽出する
 * @param userInfo ユーザー情報
 * @returns 列設定データ
 */
export const extractColumnSettingsFromUserInfo = (userInfo) => {
    if (!userInfo || !userInfo[0] || !userInfo[0].user_app_settings) {
        return null;
    }
    const columnOrderSetting = userInfo[0].user_app_settings.find((setting) => setting.type_name === "column_order");
    return columnOrderSetting ? columnOrderSetting.settings : null;
};
/**
 * ユーザー情報から職種コードを抽出する
 * @param userInfo ユーザー情報
 * @returns 職種コード
 */
export const extractJobCategoryCode = (userInfo) => {
    if (!userInfo || !userInfo[0]) {
        return null;
    }
    return userInfo[0].job_category_code_OA || null;
};
/**
 * ユーザー情報から部署コードを抽出する
 * @param userInfo ユーザー情報
 * @returns 部署コード
 */
export const extractDepartmentCode = (userInfo) => {
    if (!userInfo || !userInfo[0]) {
        return null;
    }
    return userInfo[0].department_code_OA || null;
};
